// Recent News block — AJAX filter + pagination with pushState URL state.
// Imported from js/global.js. No-op when the block isn't on the page.

const STATE_KEY = "recentNews";

export default function initRecentNews() {
  const block = document.querySelector(".aviatrix-block--recent-news");
  if (!block || typeof recentNews === "undefined") return;

  const results = block.querySelector(".recent-news__results");
  const filterBtns = block.querySelectorAll(".recent-news__filter");
  if (!results) return;

  let isLoading = false;
  let currentCategory = readActiveCategory();

  function readActiveCategory() {
    const active = block.querySelector(".recent-news__filter.is-active");
    return active ? active.getAttribute("data-category") || "" : "";
  }

  function setFilterActive(category) {
    filterBtns.forEach((btn) => {
      const isActive = (btn.getAttribute("data-category") || "") === category;
      btn.classList.toggle("is-active", isActive);
      btn.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  function updateUrl(category, page) {
    const params = new URLSearchParams(window.location.search);
    if (category) {
      params.set("recent_news_cat", category);
    } else {
      params.delete("recent_news_cat");
    }
    if (page > 1) {
      params.set("recent_news_page", page);
    } else {
      params.delete("recent_news_page");
    }
    const qs = params.toString();
    const newUrl =
      window.location.pathname +
      (qs ? "?" + qs : "") +
      window.location.hash;
    window.history.pushState({ key: STATE_KEY, category, page }, "", newUrl);
  }

  function scrollToBlockTop() {
    const top = block.getBoundingClientRect().top + window.pageYOffset - 24;
    window.scrollTo({ top, behavior: "smooth" });
  }

  async function fetchResults(category, page, options = {}) {
    if (isLoading) return;
    isLoading = true;
    results.setAttribute("aria-busy", "true");

    try {
      const body = new URLSearchParams({
        action: "recent_news_filter",
        nonce: recentNews.nonce,
        category: category || "",
        page: String(page),
      });

      const response = await fetch(recentNews.ajaxurl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body,
      });
      const data = await response.json();

      if (data && data.success) {
        results.innerHTML = data.data.html;
        currentCategory = category;
        setFilterActive(category);

        if (options.pushUrl !== false) {
          updateUrl(category, page);
        }
        if (options.scroll !== false) {
          scrollToBlockTop();
        }
      } else {
        results.innerHTML =
          '<p class="recent-news__no-results">Something went wrong loading posts. Please try again.</p>';
      }
    } catch (err) {
      console.error("Recent News fetch failed:", err);
      results.innerHTML =
        '<p class="recent-news__no-results">Something went wrong loading posts. Please try again.</p>';
    } finally {
      results.setAttribute("aria-busy", "false");
      isLoading = false;
    }
  }

  // Filter pill clicks.
  filterBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const cat = btn.getAttribute("data-category") || "";
      if (cat === currentCategory) return;
      fetchResults(cat, 1);
    });
  });

  // Pagination clicks (delegated — pagination is replaced on every fetch).
  results.addEventListener("click", (e) => {
    const pageBtn = e.target.closest("[data-page]");
    if (!pageBtn || pageBtn.classList.contains("is-current")) return;
    e.preventDefault();
    const page = parseInt(pageBtn.getAttribute("data-page"), 10);
    if (!Number.isFinite(page) || page < 1) return;
    fetchResults(currentCategory, page);
  });

  // Back/forward button — re-fetch from URL params, don't push another entry.
  window.addEventListener("popstate", (e) => {
    const state = e.state && e.state.key === STATE_KEY ? e.state : null;
    let category = "";
    let page = 1;
    if (state) {
      category = state.category || "";
      page = state.page || 1;
    } else {
      const params = new URLSearchParams(window.location.search);
      category = params.get("recent_news_cat") || "";
      page = parseInt(params.get("recent_news_page"), 10) || 1;
    }
    fetchResults(category, page, { pushUrl: false, scroll: false });
  });
}
